function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useHasPermission from '../../../helpers/hooks/useHasPermission';
import { actions as ppcActions } from '../../../reducers/ppc.reducer';
import Card from '../card/Card.react';
import CardHeader from '../card/CardHeader.react';
import CardBody from '../card/CardBody.react';
import Button from '../Button.react';
import Input from '../form/Input.react';
import Label from '../form/Label.react';
var PpcBreadcrumbs = function PpcBreadcrumbs(_ref) {
  var id = _ref.id,
    type = _ref.type,
    breadcrumbs = _ref.breadcrumbs,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$permission = _ref.permission,
    permission = _ref$permission === void 0 ? null : _ref$permission;
  var dispatch = useDispatch();
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var hasPermission = useHasPermission(permission);
  var getBreadcrumbs = function getBreadcrumbs() {
    return breadcrumbs !== null && breadcrumbs !== void 0 && breadcrumbs.label ? "> ".concat(breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.label) : '';
  };
  useEffect(function () {
    if (!breadcrumbs) return;
    setState(_objectSpread(_objectSpread({}, state), breadcrumbs));
  }, [breadcrumbs]);
  var setBanner = function setBanner(key, val) {
    setState(_objectSpread(_objectSpread({}, state), {}, _defineProperty({}, key, val)));
  };
  var getUpdateAction = function getUpdateAction() {
    switch (type) {
      case 'productCategory':
        return ppcActions.productCategory;
      case 'product':
        return ppcActions.product;
      case 'serviceCategory':
        return ppcActions.serviceCategory;
      case 'service':
        return ppcActions.service;
      case 'page':
        return ppcActions.page;
      default:
        return null;
    }
  };
  var getID = function getID() {
    switch (type) {
      case 'productCategory':
      case 'serviceCategory':
        return {
          categoryID: id
        };
      case 'product':
        return {
          productID: id
        };
      case 'service':
        return {
          serviceID: id
        };
      case 'page':
        return {
          pageID: id
        };
      default:
        return {};
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Breadcrumbs"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Label, {
    label: "Breadcrumb"
  }), /*#__PURE__*/React.createElement(Input, {
    value: state.label,
    onChange: function onChange(e) {
      return setBanner('label', e.target.value);
    },
    disabled: disabled
  }), !disabled && hasPermission && /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Update",
    apiID: "breadcrumbs",
    onClick: function onClick() {
      dispatch({
        type: getUpdateAction(),
        payload: {
          formData: _objectSpread(_objectSpread({}, getID()), {}, {
            label: (state === null || state === void 0 ? void 0 : state.label) || '',
            apiID: 'breadcrumbs'
          }),
          method: 'put',
          route: 'breadcrumbs'
        }
      });
    }
  })))));
};
export default PpcBreadcrumbs;